import { ConfirmButton } from 'components/common/DefaultFormButton';
import React, { ReactElement } from 'react';
import { GeneralFunction } from 'types/common';

const TabLayout: React.FC<{ onClick?: GeneralFunction; children: ReactElement | string; loading?: boolean }> = ({
  children,
  onClick,
  loading,
}) => (
  <div className='flex flex-col h-full '>
    <div className='flex-1 overflow-y-auto overflow-x-hidden'>{children}</div>
    <div className='m-0 p-4 flex justify-center'>
      <ConfirmButton isLoading={loading} onClick={onClick}>
        Save
      </ConfirmButton>
    </div>
  </div>
);

export default React.memo(TabLayout);
